/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Military(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0002 0.916984C12.4089 0.91707 14.7197 1.87396 16.423 3.57714C18.1262 5.28049 19.084 7.59121 19.0841 9.99999C19.0841 10.0478 19.0781 10.0943 19.0695 10.1396C19.0689 10.1425 19.0691 10.1455 19.0685 10.1484C19.0554 10.2136 19.031 10.2742 19.0021 10.332C18.9663 10.4041 18.9223 10.4723 18.8644 10.5303L10.5304 18.8633C10.2376 19.1561 9.76278 19.156 9.46988 18.8633L1.13687 10.5303C1.09 10.4834 1.05223 10.4295 1.01968 10.373C0.955964 10.2628 0.917202 10.1364 0.917144 9.99999C0.91723 7.59106 1.87392 5.28052 3.5773 3.57714C5.28068 1.87376 7.59122 0.91707 10.0002 0.916984ZM10.0002 8.24999C8.74783 8.25013 7.90879 9.06298 7.84 9.89062L10.0002 16.0625L12.1603 9.89062C12.0915 9.06299 11.2525 8.25013 10.0002 8.24999ZM4.37515 8.24999C3.35175 8.25013 2.59244 8.92057 2.44449 9.71679L8.20621 15.4785L6.37613 10.248C6.34826 10.1684 6.33414 10.0844 6.33414 9.99999C6.33414 9.08755 5.51139 8.25015 4.37515 8.24999ZM15.6252 8.24999C14.5535 8.25014 13.7705 8.98511 13.6769 9.83007L13.6671 9.99999L13.6564 10.126C13.6494 10.1673 13.639 10.2084 13.6252 10.248L11.7941 15.4785L17.5548 9.71777C17.406 8.92217 16.6427 8.25013 15.6252 8.24999ZM10.0002 2.41698C7.98904 2.41707 6.05992 3.21561 4.63785 4.63769C3.95164 5.32389 3.41149 6.12835 3.03531 7.00292C3.45081 6.83905 3.90507 6.75003 4.37515 6.74999C5.45774 6.75009 6.45911 7.23053 7.10269 8.00097C7.79345 7.22156 8.87065 6.75008 10.0002 6.74999C11.1286 6.75008 12.2048 7.22093 12.8957 7.99902C13.5375 7.22955 14.5376 6.75009 15.6252 6.74999C16.0944 6.75003 16.5486 6.83998 16.965 7.00487C16.5886 6.12978 16.049 5.32427 15.3625 4.63769C13.9404 3.21582 12.0111 2.41707 10.0002 2.41698Z"
        fill="#35424F"
      />
    </svg>
  )
}

Military.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Military
